import { render, staticRenderFns } from "./DigitalHumanAvatar.vue?vue&type=template&id=b0c24244&scoped=true&"
import script from "./DigitalHumanAvatar.vue?vue&type=script&lang=js&"
export * from "./DigitalHumanAvatar.vue?vue&type=script&lang=js&"
import style0 from "./DigitalHumanAvatar.vue?vue&type=style&index=0&id=b0c24244&prod&lang=less&scoped=true&"
import style1 from "./DigitalHumanAvatar.vue?vue&type=style&index=1&id=b0c24244&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c24244",
  null
  
)

export default component.exports